export enum TipoAreaDeInteresse {
  COMERCIAL = 1,
  TECNICA = 2,
  JURIDICCA = 3,
  FINANCEIRA = 4,
}
